(function() {
    angular
        .module("app")
        .controller("DeleteDeviceGroupModalController", DeleteDeviceGroupModalController)

    DeleteDeviceGroupModalController.$inject = [
        "$state",
        "$scope",
        "$uibModalInstance",
        "deviceGroupsService",
        "deviceGroup",
        "userMessagingService"
    ]

    function DeleteDeviceGroupModalController(
        $state,
        $scope,
        $uibModalInstance,
        deviceGroupsService,
        deviceGroup,
        userMessagingService
    ){

        $scope.deviceGroup = {
            name: deviceGroup.name
        }

        $scope.ok = function() {
            $uibModalInstance.close(
                deviceGroupsService.deleteDeviceGroup(
                    deviceGroup.id,
                    function() {
                        //Success
                        userMessagingService.success("Project Successfully Deleted")
                    },
                    function(errorMessage) {
                        //Failure
                        userMessagingService.error("Project Delete Failed: " + errorMessage)
                    })
            )
        }

        $scope.cancel = function() {
            $uibModalInstance.dismiss("cancel")
        }
    }
})()
